import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@coolblue-development/freddy';
import addAccessoryToCartTrigger from '@coolblue-development/ga4-events/triggers/MiniProductPage/addAccessoryToCartTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { AddToCartButton } from '@coolblue-development/next-shopping-cart/client';
import React, { useState } from 'react';
import { useTranslation } from '../../i18n/useTranslation.js';
export default function MiniProductPageFooter({ productData, subFeature, mainProductId, index, totalIndices, handleClose, ctaRef, customCta, isBusinessCustomer = false, quantity, }) {
    const { t } = useTranslation('miniProductPage');
    const { trackEvent } = useAnalytics();
    const [isLoading, setIsLoading] = useState(false);
    const addToCartProduct = productData;
    const handleOnClick = () => {
        var _a;
        setIsLoading(true);
        (_a = ctaRef === null || ctaRef === void 0 ? void 0 : ctaRef.current) === null || _a === void 0 ? void 0 : _a.click();
        if (!customCta && index !== undefined && totalIndices && subFeature && mainProductId) {
            trackEvent(addAccessoryToCartTrigger({
                sub_feature: subFeature,
                primary_item_id: mainProductId,
                attached_item_id: productData.id,
                index: index,
                total_indices: totalIndices,
            }));
        }
        handleClose();
    };
    const CtaButtonElement = () => customCta ? (React.cloneElement(customCta, { onClick: () => handleOnClick() })) : (_jsx(AddToCartButton, { label: t('addToCartLabel'), ariaLabel: t('addToCartLabel'), isFullWidth: true, disabled: !addToCartProduct, loading: isLoading, onClick: () => handleOnClick() }));
    if (isBusinessCustomer) {
        return (_jsxs(Flex, { flex: 1, direction: {
                xs: 'column',
                md: 'row',
            }, gap: 200, alignItems: { md: 'center' }, justifyContent: "space-between", children: [_jsx(Flex, { flex: 1, children: quantity }), _jsx(Flex, { flex: { xs: 2, md: 1 }, children: _jsx(CtaButtonElement, {}) })] }));
    }
    return _jsx(CtaButtonElement, {});
}
//# sourceMappingURL=MiniProductPageFooter.js.map